export default __webpack_public_path__ + "static/media/Caulk&Sealant.9e66518a.png";